import * as React from 'react';
import HistoryRowVerticalItem from 'Components/HistoryRowVerticalItem';
import { formatPartialDate } from 'Utility/date';
import { newButton } from '../../../../utils/functions';
import { isNil } from 'Utility/ramdaReplacement';
import type { IHistoryContext } from 'Containers/FormContextHandler';
import HistoryRow from 'Components/HistoryRow';
import { filterDocumentsByType, sortDocumentsDescending } from 'Utility/documentHandling';
import { editHistoryMenuItems } from 'Components/HistoryRowControls/EditHistory/EditHistoryDialog';
import { Container, Item } from 'Components/Grid';
import colors from '../../../../../../config/theme/colors';
import { styled } from '@mui/material';

const StyledLocationRow = styled(Container)(({ theme }) => ({
  '* > &:not(:last-child)': {
    borderBottom: '0.1rem solid ' + colors.gray + '66',
    paddingBottom: '0.75rem',
    marginBottom: '0.75rem',
  },
}));

const PolyneuroSymptoms = ({
  documents = [],
  startEdit,
  fm,
}: IHistoryContext<IPolyneuroSymptoms>): React.JSX.Element => {
  const polyneuroSymptoms = filterDocumentsByType(documents, ['polyneuroSymptoms']).sort(sortDocumentsDescending).at(0);

  return (
    <HistoryRow
      headerText={fm('diagnosis.polyneuro.symptoms.title')}
      rowButton={
        startEdit
          ? newButton(
              'polyneuroSymptoms',
              startEdit(polyneuroSymptoms ?? {}, 'polyneuroSymptoms'),
              'general.edit',
              undefined,
              undefined,
              !isNil(((polyneuroSymptoms ?? {}) as IControlProps)._lockedFor),
              undefined,
              undefined,
              polyneuroSymptoms,
            )
          : undefined
      }
      menuItems={editHistoryMenuItems(polyneuroSymptoms)}
    >
      <React.Fragment>
        <HistoryRowVerticalItem
          header={fm('diagnosis.symptomOnsetDate')}
          value={
            polyneuroSymptoms?.symptomOnsetDate ? (
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                {formatPartialDate(polyneuroSymptoms.symptomOnsetDate)}
              </div>
            ) : (
              ' - '
            )
          }
        />
        <HistoryRowVerticalItem
          header={fm('diagnosis.polyneuro.symptoms.timeCourse.title')}
          value={
            polyneuroSymptoms?.timeCourse &&
            fm('diagnosis.polyneuro.symptoms.timeCourse.' + polyneuroSymptoms?.timeCourse)
          }
        />
        {polyneuroSymptoms?.symptoms?.map(symp => {
          const symptomLocationData = polyneuroSymptoms?.symptomLocations?.find(sl => sl.symptom === symp);
          return (
            <Container
              key={symp}
              style={{
                backgroundColor: colors.lightestGray,
                borderRadius: '0.5rem',
                marginBottom: '1rem',
                padding: '1rem',
              }}
            >
              <Item xs={5}>
                <div style={{ color: colors.darkGray }}>{fm('diagnosis.polyneuro.symptoms.symptom.title')}</div>
                <div style={{ fontWeight: 600 }}>{fm('diagnosis.polyneuro.symptoms.symptom.' + symp)}</div>
              </Item>
              <Item xs={true}>
                {symptomLocationData?.locations?.map(sld => (
                  <>
                    <StyledLocationRow>
                      <Item xs={3}>
                        <div style={{ color: colors.darkGray }}>
                          {fm('diagnosis.polyneuro.symptoms.location.title')}
                        </div>
                        <div style={{ fontWeight: 600 }}>
                          {fm('diagnosis.polyneuro.symptoms.location.' + sld.location)}
                        </div>
                      </Item>
                      {sld.locationDetail && (
                        <Item xs={3}>
                          <div style={{ color: colors.darkGray }}>
                            {fm('diagnosis.polyneuro.symptoms.locationDetail.title')}
                          </div>
                          <div style={{ fontWeight: 600 }}>
                            {fm('diagnosis.polyneuro.symptoms.locationDetail.' + sld.locationDetail)}
                          </div>
                        </Item>
                      )}
                      {sld.locationDetail2 && (
                        <Item xs={3}>
                          <div style={{ color: colors.darkGray }}>
                            {fm('diagnosis.polyneuro.symptoms.locationDetail2.title')}
                          </div>
                          <div style={{ fontWeight: 600 }}>
                            {fm('diagnosis.polyneuro.symptoms.locationDetail2.' + sld.locationDetail2)}
                          </div>
                        </Item>
                      )}
                    </StyledLocationRow>
                  </>
                ))}
              </Item>
            </Container>
          );
        })}
      </React.Fragment>
    </HistoryRow>
  );
};

export default PolyneuroSymptoms;
